(function(){"use strict";try{if(typeof document!="undefined"){var e=document.createElement("style");e.appendChild(document.createTextNode("")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsx as H } from "react/jsx-runtime";
import $ from "clsx";
import { useState as c, useCallback as v, useEffect as j } from "react";
const B = ({
  color: w,
  offset: g,
  height: E,
  global: m,
  scroll: u,
  onScroll: d,
  onScrollTarget: e,
  triggerOnce: h,
  containerRef: t,
  className: x,
  ...L
}) => {
  const k = $("scrollStatus", x), y = { top: g ? `${g}px` : "0px" }, [l, C] = c(0), [o, P] = c(!1), [i, b] = c(!1), p = v(() => {
    var s;
    return m ? {
      scrollHeight: window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0,
      fullHeight: document.documentElement.scrollHeight - window.innerHeight || ((s = document.scrollingElement) == null ? void 0 : s.clientHeight) || 0
    } : {
      scrollHeight: t == null ? void 0 : t.current.scrollTop,
      fullHeight: (t == null ? void 0 : t.current.scrollHeight) - (t == null ? void 0 : t.current.clientHeight)
    };
  }, [m, t]), r = v(() => {
    const { scrollHeight: s, fullHeight: n } = p();
    if (C(s / n * 100), d == null || d(l), !e || o || !u)
      return;
    (!i && l >= u || i && l <= u) && (b((z) => !z), e == null || e(), h && P(!0));
  }, [
    p,
    d,
    e,
    o,
    u,
    i,
    l,
    h
  ]);
  return j(() => {
    const s = (t == null ? void 0 : t.current) || window;
    return s.addEventListener("scroll", r), s.addEventListener("resize", r), () => {
      s.removeEventListener("scroll", r), s.removeEventListener("resize", r);
    };
  }, [r, t]), /* @__PURE__ */ H("div", { className: k, style: y, ...L, children: /* @__PURE__ */ H("div", { style: { width: `${l}%`, backgroundColor: w, height: E } }) });
};
B.defaultProps = {
  color: "#1266F1",
  height: "10px",
  triggerOnce: !0
};
export {
  B as MDBScrollStatus
};
